'use client';
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Image from 'next/image';
import PlanCard from '@/app/_components/subscription/PlanCard';
import { UserSubscription } from '@/app/_lib/interfaces';
import { isB2BSubscription } from '@/app/_lib/subscription';

interface Props {
  userSubscription: UserSubscription;
  isOpen: boolean;
  handleOpen: (o: boolean) => void;
}
const PlanDetails = ({ userSubscription, isOpen, handleOpen }: Props) => {
  return (
    <Transition show={isOpen}>
      <Dialog
        as="div"
        className="fixed top-0 left-0 bottom-0 right-0 z-50 p-6 flex items-center justify-center min-h-full min-w-full h-screen"
        onClose={() => handleOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="ease-in opacity-0"
          enterTo="ease-out opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50 min-h-screen"></div>
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel className="relative overflow-hidden rounded bg-white transition-all w-full md:w-2/3 lg:w-1/3 mt-10 mb-16 md:m-10 max-h-[calc(100%-80px)]">
            <Dialog.Title
              as="div"
              className="text-xl font-sans leading-6 flex justify-between gap-2.5 py-8 md:py-8 px-6"
            >
              <h3 className="text-2xl" data-test-id="plan-details-header">
                <span className="font-bold">
                  {userSubscription.subscription_plan.name}
                </span>{' '}
                - Plan Details
              </h3>
              <button
                type="button"
                className="-m-3 p-3 focus-visible:outline-offset-[-4px] text-white"
                data-dd-action-name="Close modal"
                onClick={() => handleOpen(false)}
                data-test-id="close-modal"
              >
                <Image
                  src="/icons/close.svg"
                  alt="close share modal"
                  height={16}
                  width={16}
                />
              </button>
            </Dialog.Title>
            <div>
              <div className="md:pt-4 md:pb-10 px-6">
                <PlanCard
                  subscriptionPlan={userSubscription.subscription_plan}
                />
              </div>
              <div className="flex flex-row justify-end gap-2.5 px-6 py-4">
                <button
                  className="btn-tertiary mr-4"
                  onClick={() => {
                    handleOpen(false);
                  }}
                  data-test-id="cancel-dialog"
                >
                  Close
                </button>

                {isB2BSubscription(userSubscription) ? null : (
                  <a
                    className="btn-primary"
                    data-test-id="manage-plan"
                    href={process.env.NEXT_PUBLIC_APP_STORE_URL}
                    target="_blank"
                  >
                    Manage Plan
                  </a>
                )}
              </div>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export { PlanDetails };
